module.exports = __webpack_public_path__ + "img/tzgg.8b6d7cac.png";